import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { CallController } from '@gem/call/CallController/CallController';
import { Call } from '@gem/call/CallStore/Call';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';

import { NewRecording } from './NewRecording/NewRecording';
import { useStartRecordingPopupPresenter } from './StartRecordingPopup.presenter';
import styles from './StartRecordingPopup.styles.m.css';

interface IStartRecordingPopupProps {
  call: Call;
  callController: CallController;
}

export const StartRecordingPopup: FC<ICommonPopupsProps<IStartRecordingPopupProps>> = observer(
  ({ popupInstance, params }) => {
    const { call, callController } = params!;
    const { t } = useTranslation();
    const presenter = useStartRecordingPopupPresenter({
      popupInstance,
      call,
      callController,
    });

    return (
      <Popup
        title={t('calls_recording_screen_title')}
        className={styles.container}
        isOpened
        onClose={popupInstance.close}
      >
        <NewRecording
          onSuccess={presenter.onSuccess}
          call={call}
          callController={callController}
        />
      </Popup>
    );
  }
);
